function devtricker_changeLikeIconTo(style) {
    const iconElement = document.getElementById('like-post-button-svg');
    if (!iconElement) return;

    iconElement.classList.remove('icon-thin-heart', 'icon-thin-heart-fill');

    const newClass = style === 'fill' ? 'icon-thin-heart-fill' : 'icon-thin-heart';
    iconElement.classList.add(newClass);
}

function devtricker_changeLikeTooltipTextTo(text) {
    let button = document.getElementById('like-post-button');
    if (button) {

        button.setAttribute('data-bs-title', text);

        let bootstrapTooltip = bootstrap.Tooltip.getInstance(button);
        if (bootstrapTooltip) {
            bootstrapTooltip.setContent({ '.tooltip-inner': text });
        }
    }
}

function devtricker_getNumberOfLikes() {
    const button = document.getElementById('like-post-button');
    if (!button) return undefined;

    const likesText = button.getAttribute('data-bs-title');
    if (!likesText) return undefined;

    const match = likesText.match(/\d+/);
    if (match) {
        return parseInt(match[0], 10);
    } else {
        return undefined;
    }
}

function devtricker_getTheLikeText(isToIncrease) {
    let likeCounter = devtricker_getNumberOfLikes();

    if (likeCounter === undefined) {
        likeCounter = 0;
    }

    if (isToIncrease) {
        likeCounter++;
    } else {
        likeCounter = Math.max(0, likeCounter - 1);
    }

    toolTipText = likeCounter === 1 ? g_devtricker_i18n.one_like.replace('%s', likeCounter) : g_devtricker_i18n.more_likes.replace('%s', likeCounter);

    return toolTipText;
}


function devtricker_dom_get_portLikeButton() {
    return document.getElementById('like-post-button');
}

function devtricker_dom_set_changeLikeIconTofilled() {
    devtricker_changeLikeIconTo('fill');
}


function devtricker_dom_setchangeLikeIconToFilledAnnimated() {
    devtricker_changeLikeIconTo('fill');
    devtricker_changeLikeTooltipTextTo(devtricker_getTheLikeText(true));
}

function devtricker_dom_setchangeLikeIconToOriginal() {
    devtricker_changeLikeIconTo('default');
    devtricker_changeLikeTooltipTextTo(devtricker_getTheLikeText(false));
}